export default __webpack_public_path__ + "static/media/IMG4.8533f917.jpg";